export class mdlAdditionalCovers{
    public CoverCode: string;
    public Amount: number;
    public Vat_Amount: number;
    public IsMandatory: boolean;
    public CoverDesc_Ar: string;
    public CoverDesc_En: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlAdditionalCovers.ts